import collapseGroup from '../generic/collapseGroup';
import ticker from './ticker';
import analytics from '../analytics';

// TO-DO refactor this into a modern class.

/**
 * Reduces "scope" where this navigation module is poking DOM.
 * @type {Element}
 */
let headerElement;

/**
 * Mobile navigation element
 * @type {Element}
 */
let mobileNavigation;

/**
 * stores the previous hidden state. If there is no change to this between scroll observer, no need to update anything.
 * @type {boolean}
 */
let prevHiddenState;

/**
 * External methods may register a callback here to subscribe notifications for changes in nav area vacancy (as in: is the nav currently occupying the top of the screen)
 * @type {method[]}
 */
const vacancyObservers = [];

/**
 * TOGGLERONE FUNCTIONS (Functions that show or hides elements )
 */

/**
 * Shows, hides or toggles visibility of navigation menu dropdown elements
 * @param {boolean} [show] if true element is shown, if false is passed element is hide. If parameter is undefined is visibility is toggled.
 */
function toggleAllDropdownFloats(show) {
  toggleAllElements('.dropdown-floats', 'dropdown-floats--visible', show);
}

/**
 * Toggle element class on or off
 * WHy to do it like this? IE11 don't support Element.classlist.toggle function's second argument.
 * @param {Element} element element to be manipulated
 * @param {string} className class to name to be toggled
 * @param {boolean} [force] forces class off or on, if argument is not passed toggling happens normal way.
 */
function toggleElement(element, className, force) {
  const show = typeof force === 'undefined' ? !element.classList.contains(className) : force;
  element.classList.toggle(className, show);
}

function toggleAllElements(selector, className, force) {
  headerElement.querySelectorAll(selector).forEach(element => {
    toggleElement(element, className, force);
  });
}

/**
 * Shows, hides or toggles visibility of mobile navigation menu
 * @param {boolean} [show] if true element is shown, if false is passed element is hide. If parameter is undefined is visibility is toggled.
 */
function toggleMobileNavigationMenu(show) {
  const body = document.querySelector('body');

  if (typeof show === 'undefined') {
    show = !document.querySelector('body').classList.contains('wuwei-mobile-navigation--open');
  }

  headerElement.querySelector('.menu .f-icon--x').classList.toggle('hidden', !show);
  headerElement.querySelector('.menu .f-icon--menu').classList.toggle('hidden', show);

  body.classList.toggle('wuwei-mobile-navigation--open', show);
  body.classList.toggle('wuwei-mobile-navigation--closed', !show);

  mobileNavigation.classList.toggle('wuwei-mobile-navigation--ticker-open', ticker.isOpen());

  //Prevent background scrolling under the overlay layer.
  //This rule is hard to put to SCSS file, wuwei-mobile-navigation.scss file all css produced there is wrapped around .wuwei class.
  if (show) {
    body.style.overflow = 'hidden';
  } else {
    body.style.overflow = '';
  }

  collapseGroup.resize();
}

/**
 * Is mobile navigation open or closed
 * @return {boolean} return true if navigation menu is open, false if it is closed
 */
function isMobileNavigationOpen() {
  return headerElement && headerElement.querySelector('.wuwei-mobile-navigation').classList.contains('wuwei-mobile-navigation--open');
}

/**
 * Remove `.wu-button-container-open` class from all navigation items.
 */
function removeNavigationItemsUpArrows() {
  headerElement.querySelectorAll('.wu-button-container--open').forEach(element => {
    element.classList.remove('wu-button-container--open');
  });
}

/**
 * EVENT HANDLERS
 */

/**
 * Called when a navigation menu item is clicked.
 * @param {Event} event - event object
 */
function openNavigationMenu(event) {
  let dropDownTarget;
  const targetElement = event.target;

  if (targetElement && targetElement.closest) {
    dropDownTarget = targetElement.closest('a').dataset.target;
  }

  //Prevents event bubbling to $(window).click listener, prevent closing all dropdowns
  //when a dropdown is clicked.
  if (dropDownTarget) {
    event.stopPropagation();
    event.preventDefault();

    const selector = `.dropdown-floats[data-target="${dropDownTarget}"]`;
    const isOpen = headerElement.querySelector(selector).classList.contains('dropdown-floats--visible');

    removeNavigationItemsUpArrows();

    if (!isOpen) {
      toggleAllDropdownFloats(false);      

      //Add small carrot to opened navigation item..
      const buttonContainerElement = event.currentTarget.closest('.wu-button-container');
      buttonContainerElement.classList.add('wu-button-container--open');
    }

    headerElement.querySelector(selector).classList.toggle('dropdown-floats--visible', !isOpen);

    const genericButton = targetElement.closest('.generic-button');

    if (genericButton) {
      genericButton.setAttribute('data-gtm-type', isOpen ? 'Close' : 'Open');
    }
  }
}

/**
 * Called on mobile burger menu is clicked
 * @param {Event} event - click event object
 */
function _onMobileMenuBurgerClicked(event) {
  event.preventDefault();
  event.stopPropagation();
  toggleAllDropdownFloats(false);
  toggleMobileNavigationMenu();
}

function closeEverything() {
  toggleAllDropdownFloats(false);  
  removeNavigationItemsUpArrows();
}

/**
 * Open new cars menu, if #new-cars-menu hash exists in url
 */
function openNewCarsMenu() {
  if (window.location.hash && window.location.hash === '#new-cars-menu') {
    const newCarsMenuContainer = document.querySelector('a.new-cars-menu').parentNode,
      // Kinda stupid to search with data-target (actually the whole concept is kinda stoopid),
      // but what would you do for the sake of the customer and the advertising agency ¯\_(ツ)_/¯
      // Hopefully this is only temporary campaign so we can destroy this thingy as soon as possible
      subMenuContainer = document.querySelector('.elevated-container[data-target="kh9XR6VSQCaTw4wKCXlLLQ"]');

    newCarsMenuContainer.classList.add('wu-button-container--open');
    subMenuContainer.classList.add('dropdown-floats--visible');
  }
}

const carSearchToggleElement = document.querySelector('.car-search-toggle');
const offersAndEvents = document.querySelector('.offers-and-events');

/**
 * Function is called when user scrolls
 * @param {integer} scrollPosition scrolling position
 * @param {boolean} scrollingUp true if scrolling up false otherwise
 */
function onScroll(scrollPosition, scrollingUp) {
  const headerHeight = 168;
  const threshold = 150; //px

  let isHidden = false;

  if (!ticker.isOpen()) {
    //Is user scrolling up, if so show menu instantly
    if (scrollingUp) {
      isHidden = false;
    } else {
      isHidden = scrollPosition > threshold && !isMobileNavigationOpen();
    }
  }

  if (headerElement && prevHiddenState !== isHidden) {
    if (isHidden) {
      headerElement.style.top = `-${headerHeight}px`;
    } else {
      headerElement.style.top = '0px';
    }

    // In small breakpoint the nav style "position" is chnged from "static" to
    // "fixed" and the navigation starts actually hiding and revealing, but on wider
    // breakpoint it just gets the top style, but it has no effect because the element is
    // positioned static, and thus it's not actually  occupying the screen. So in order to know
    // if top area is occupied  by nav, also need to check if nav is currently fixed.

    const style = window.getComputedStyle(headerElement);

    let vacancyStatus = isHidden || style.position !== 'fixed';
    // Vacancy status is delegated to vacancy observers.
    vacancyObservers.map(vo => {
      // If the area is vacant, the next observer may occupy it and returns the new vacancy state
      // (at least in theory. Hasn't been battle tested with multiple observers for reals.)
      vacancyStatus = vo(vacancyStatus);
    });

    prevHiddenState = isHidden;
  }

  if (carSearchToggleElement) {
    carSearchToggleElement.classList.toggle('open', !isHidden);
  }

  if (offersAndEvents) {
    offersAndEvents.classList.toggle('offers-and-events--navigation-open', !isHidden);
  }
}

/**
 * Bind navigation event listener functions to DOM.
 */
function init() {
  // For the advertising agency new cars campaign
  // See more details inside of this function
  openNewCarsMenu();

  headerElement = document.querySelector('header.v10');

  if (headerElement) {
    mobileNavigation = document.querySelector('.wuwei-mobile-navigation');

    // To prevent an annoying flash of the hiding animation playing unintentionally on page load, or on first click
    // Force the hiding animation to play right away when the page loads.
    // 1) the animated elements (overlay and nav bar) are hidden
    // 2) The closed-class is added to body (this triggers the animation, but the elements are inivisble)
    // 3) After 1 second delay the animation has played, and the visibility of the elements is restored
    if( mobileNavigation ) {
      mobileNavigation.style.visibility = 'hidden';

      document.querySelector('.wuwei-mobile-navigation-overlay').style.visibility = 'hidden';
      document.querySelector('body').classList.toggle('wuwei-mobile-navigation--closed', true);
      
      setTimeout(() => {
        document.querySelector('.wuwei-mobile-navigation').style.visibility = 'visible';
        document.querySelector('.wuwei-mobile-navigation-overlay').style.visibility = 'visible';
      }, 1000);      
    }  
    headerElement.querySelectorAll('.dropdown-floats').forEach(element => {
      element.addEventListener('click', event => {
        //This stop navigation to close is dropdown white background is clicked
        event.stopPropagation();

        //Analytics handle generic element click function is needed to call
        //here because event.stopProgation is called. Event is is not "bubbling" to other event listeners because of it.
        analytics.handleGenericElementClick(event);
      });
    });

    //This should bind to close and hamburger icons.. :3
    headerElement.querySelectorAll('.menu .f-icon').forEach(element => {
      element.addEventListener('click', _onMobileMenuBurgerClicked);
    });

    headerElement
      .querySelectorAll(
        '.wuwei-mobile-navigation .generic-link, .brand-modal .brand-list a',
      )
      .forEach(element => {
        element.addEventListener('click', event => {
          event.stopPropagation();
          if (
            element.classList.contains('generic-ext-button') ||
            element.classList.contains('generic-link') ||
            element.classList.contains('generic-analytics')
          ) {
            const data = analytics.extractAnalyticData(element);
            analytics.pushUIInteractionAnalytics(data);
          }
        });
      });

    headerElement.querySelectorAll('a.navigation-menu-button, a.top-right-menu-button').forEach(element => {
      element.addEventListener('click', openNavigationMenu);
    });

    window.addEventListener('click', event => {
      if (!event.target.closest('.navigation-menu-button')) {
        closeEverything();
      }
    });
  }
}

/**
 * callback method that subscribes for changes in navigation area vacancy.
 * The nav bar currently may or may not occupy the area. When there are changes,
 * this will be called to notify the listener.
 * Since only one element can occupy the space, but multiple could in theory observe it, the
 * vacancy status should be returned from each observer and passed to the next.
 * @param  {function} method a callback method which should:
 *                           1) accept a boolean status parameter where
 *                                true = vacant, the nav area is available for other content
 *                                false = occupied, other content in this area should be hidden
 *                           2) return a new vacant status. If the observer gets notified of vacancy,
 *                                but doesn't use it, it remains vacant and can be offered to the next observer (if any).
 */
function registerVacancyObserver(method) {
  if (typeof method === 'function') {
    vacancyObservers.push(method);
  }
}

export default {
  onScroll,
  init,
};

export { onScroll, init, registerVacancyObserver };
